import React from 'react';
import { authRoles } from 'src/app/auth';

const VoipPage = React.lazy(() => import('./voip/VoipPage'));
const TicketsPage = React.lazy(() => import('./tickets/TicketsPage'));
const NotificationsPage = React.lazy(() => import('./notifications/NotificationsPage'));
const NewNotificationsPage = React.lazy(() => import('./notifications/NewNotification'));
const NewGroupPage = React.lazy(() => import('./notifications/NewGroup'));

const CommunicationsConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  auth: authRoles.admin,

  routes: [
    {
      path: 'communications/voip',
      element: <VoipPage />,
      auth: null,
    },
    {
      path: 'communications/tickets',
      element: <TicketsPage />,
      auth: null,
    },
    {
      path: 'communications/notifications',
      element: <NotificationsPage />,
      auth: null,
    },
    {
      path: 'communications/new-notification',
      element: <NewNotificationsPage />,
      auth: null,
    },
    {
      path: 'communications/new-group',
      element: <NewGroupPage />,
      auth: null,
    },
  ],
};

export default CommunicationsConfig;
